import { useState } from 'react'
import { useAppDispatch } from '../redux/types/types'
import { useToast } from '../context/ToastContext'
import { createClaimComments, getCurrentClaim } from '../redux/actions/claimsAction'

interface UseClaimCommentsParams {
  claimId: string | undefined
  token: string
  currentClaimId: number
}

export const useClaimComments = ({ claimId, token, currentClaimId }: UseClaimCommentsParams) => {
  const [commentFile, setCommentFile] = useState<File[]>([])
  const [isCommentLoading, setIsCommentLoading] = useState(false)
  const { showSuccess, showError } = useToast()
  const dispatch = useAppDispatch()

  const createCommentFormData = (text: string): FormData => {
    const formData = new FormData()
    if (commentFile) {
      for (let i = 0; i < commentFile.length; i++) {
        formData.append('file', commentFile[i])
      }
    }
    formData.append('requestId', String(currentClaimId))
    formData.append('text', text)
    return formData
  }

  const postNewCommentHandler = async (text: string): Promise<void> => {
    if (!text.trim()) {
      showError('Текст обязателен')
      return
    }
    setIsCommentLoading(true)
    try {
      const formData = createCommentFormData(text)
      const resultAction = await dispatch(createClaimComments({ formData }))
      if (createClaimComments.rejected.match(resultAction)) {
        showError('Произошла ошибка при создании комментария')
      } else {
        showSuccess('Комментарий успешно создан')
        if (claimId && token) {
          await dispatch(getCurrentClaim({ claimId, token }))
        }
        setCommentFile([])
      }
    } finally {
      setIsCommentLoading(false)
    }
  }

  return {
    commentFile,
    setCommentFile,
    isCommentLoading,
    postNewCommentHandler,
  }
}
